import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#AEAEB2",
      "fill-rule": "evenodd",
      d: "M13.185 2.816c.26.26.26.683 0 .943l-9.428 9.428a.667.667 0 1 1-.942-.943l9.428-9.428c.26-.26.682-.26.942 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#AEAEB2",
      "fill-rule": "evenodd",
      d: "M2.817 2.816c.26-.26.682-.26.943 0l9.427 9.427a.667.667 0 1 1-.943.942L2.817 3.76a.667.667 0 0 1 0-.943",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }